import { render, staticRenderFns } from "./FileContentTabs.vue?vue&type=template&id=dffa1ace&scoped=true&"
import script from "./FileContentTabs.vue?vue&type=script&lang=js&"
export * from "./FileContentTabs.vue?vue&type=script&lang=js&"
import style0 from "./FileContentTabs.vue?vue&type=style&index=0&id=dffa1ace&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffa1ace",
  null
  
)

export default component.exports